/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { changeZakatDateGetResponseSchema } from './changeZakatDateGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getChangeZakatDate200Schema = z.lazy(() => changeZakatDateGetResponseSchema);

/**
 * @description 505 response
 */
export const getChangeZakatDate505Schema = z.any();

export const getChangeZakatDateQueryResponseSchema = z.lazy(() => getChangeZakatDate200Schema);
